import { render, staticRenderFns } from "./ComponentGraphRenderer.vue?vue&type=template&id=23cdb48c&"
import script from "./ComponentGraphRenderer.vue?vue&type=script&lang=js&"
export * from "./ComponentGraphRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ComponentGraphRenderer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports